import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=290524ab&scoped=true"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"
import style0 from "./OtpInput.vue?vue&type=style&index=0&id=290524ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290524ab",
  null
  
)

export default component.exports